<template>
    <div>
        <!-- 如果正在编辑 -->
        <template v-if="canEdit">
            <el-input style="width: 90%;" :type="inputType" ref="input" v-model="value_a" @blur="onBlur"
                @keyup.enter.native="onKeyUp" :placeholder="placeholder" />
        </template>
        <!-- 如果不是编辑状态 -->
        <template v-else>
            <div :class="className" class="ant-typography">
                <span v-if="inputType === 'input'" class="content" v-html="formattedValue" @click="toDoEdit"></span>
                <span v-else class="textareaContent" v-html="formattedValue" @click="toDoEdit"></span>
                <div @click="toDoEdit" role="button" tabindex="0" class="ant-typography-edit" :aria-label="$t('pageDecorate.ariaEdit')">
                    <img v-if="editBlack" class="editBlack" src="@/assets/images/schoolAbility/editBlack.png" />
                    <img v-else class="editWhite" src="@/assets/images/schoolAbility/editWhite.png" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name: 'EditInput',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        TextStyle: {
            type: Object,
            default: () => ({})
        },
        attrName: {
            type: String,
            default: ''
        },
        editBlack: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            canEdit: false,
            value_a: this.value,
        };
    },
    computed: {
        inputType() {
            return this.type === 'TextArea' ? 'textarea' : 'input';
        },
        formattedValue() {
            return (this.value_a || this.placeholder || '').replace(/[\n]/g, '<br/>');
        }
    },
    methods: {
        toDoEdit() {
            console.log(this.editBlack);

            this.canEdit = true;
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },
        onKeyUp() {
            if (this.type !== 'TextArea') {
                this.canEdit = false;
                this.$emit('change', this.value_a, this.attrName)
            }
        },
        onBlur() {
            this.canEdit = false;
            this.$emit('change', this.value_a, this.attrName)
        },
    }
};
</script>

<style lang="scss" scoped>
.middle {
    justify-content: center;
}

.ant-typography {
    display: flex;

    .ant-typography-edit {
        padding-top: 4px;
        padding-left: 4px;

        img {
            max-height: 80%;
        }
    }

    .content {
        max-width: 90%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>